/**
 * Created by mykurisu on 2017/9/13.
 */
import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import {ActionSheet, Toptips, Toast} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import {WKInfiniteScroll, WKCommentDialog} from '../../components/wk'
import {getHumanTime, removeAds} from '../../utils'
import {NoneItem} from '../../components/details'
import Zan from '../../images/recorded/zan.png'
import ZanOn from '../../images/recorded/zan__on.png'
import topCommentImg from '../../images/recorded/top-comment.png'
import ToCreateLiveroom from '../../images/to_create_liveroom2.png'


class DiscussItem extends React.Component{
    getLiveroomName (name) {
        if (name.length > 15) {
            return name.substring(0, 15) + '...'
        } else {
            return name
        }
    }
    render() {
        const {content} = this.props;

        return (
            <div className="discuss-item">
                <div className="item-header">
                    <div className="header-icon">
                        <img src={content.account.avatar_url} alt=""/>
                    </div>
                    <div className="header-name" onClick={
                        ((this.props.role.is_manager || this.props.account.id === content.account.id) && !content.is_fake)
                            ? () => this.props.handleSheetShow({dis: content.id, userid: content.account.id, content: content})
                            : null
                    }>
                        <p className='nickname'>
                            {removeAds(this.getLiveroomName(content.account.nickname))}
                            {content.is_top && <span className="icon"><img src={topCommentImg} alt=""/></span>}
                        </p>
                        <p>{getHumanTime(content.timestamp)}</p>
                    </div>
                    <div className="header-setting" onClick={content.is_fake ? null : () => this.props.handleZan(content)}>
                        <img src={content.is_liked ? ZanOn : Zan} alt=""/>
                        <span>{content.like_count || 0}</span>
                    </div>
                </div>
                <div className="item-text">
                    <p onClick={
                        ((this.props.role.is_manager || this.props.account.id === content.account.id) && !content.is_fake)
                            ? () => this.props.handleSheetShow({dis: content.id, userid: content.account.id, content: content})
                            : null
                    }>{content.content}</p>
                    {content.replies && content.replies.length > 0 &&
                    <div className="reply__list">
                        {content.replies.map((item) => {
                            return (
                                <div className="reply__list-item" key={item.id} onClick={(!this.props.role.is_manager || item.is_fake) ? null : () => this.props.handlewReplySheet({
                                    content: content,
                                    item: item
                                })}>
                                    <span>{item.account.nickname}回复：</span>
                                    <span>{item.content}</span>
                                </div>
                            )
                        })}
                    </div>
                    }
                </div>
            </div>
        )
    }
}

class DiscussNone extends React.Component {
    render() {
        return (
            <div className="discuss-none">
                <NoneItem
                    img="https://static-1253442168.image.myqcloud.com/picture/5915685_83a6201fde722ab5078f24fe171ed444.jpg"
                    text="期待你的评论"
                />
            </div>
        )
    }
}

class DiscussArea extends React.Component {

    constructor() {
        super();
        this.state = {
            inputDialog: false,
            loading: false,
            list: null,
            count: null,
            isShowSuccessToast: false,
            successToastText: '',
            DialogButtons: [
                {
                    type: 'default',
                    label: '取消',
                    onClick: () => this.handleDialogHide()
                },
                {
                    type: 'primary',
                    label: '发送',
                    onClick: () => {
                        this.handleSendDiscuss();
                        if (this.state.inputValue !== ''){
                            this.setState({
                                inputDialog: false
                            })
                        }
                    }
                },
            ],
            inputValue: '',

            discussSheetShow: false,
            deleteDiscussSheetShow: false,
            selectedId: null,
            selectedUserId: null,
            selectedContent: null,
            actions: [
                {
                    label: '取消',
                    onClick: () => {
                        this.setState({
                            discussSheetShow: false
                        })
                    }
                }
            ],
            deleteActions: [
                {
                    label: '取消',
                    onClick: () => {
                        this.setState({
                            deleteDiscussSheetShow: false
                        })
                    }
                }
            ],
            showWarn: false,
            tipsContent: '',
            isReply: false,
            errorMsg: '',
            sendSuccess: false,
            sendingZan: false
        }
    }

    componentDidMount() {
        this.fetchComments()
    }

    fetchComments () {
        axios.get(`/api/lecture/${this.props.lectureId}/filtered_discuss/list`)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        list: res.data.data,
                        count: res.data.data.discusses.length,
                    })
                }
            })
    }

    showSuccessToast (text) {
        this.setState({ isShowSuccessToast: true, successToastText: text })
        setTimeout(() => {
            this.setState({ isShowSuccessToast: false })
        }, 1000)
    }

    componentWillUnmount() {
        this.warnTimer && clearTimeout(this.warnTimer);
        this.toastTimer && clearTimeout(this.toastTimer);
    }

    handleSheetShow(info) {
        this.setState({
            discussSheetShow: true,
            selectedId: info.dis,
            selectedUserId: info.userid,
            selectedIsTop: info.content.is_top,
            selectedIsNice: info.content.is_filtered,
        })
    }

    handleDialogHide() {
        this.setState({
            inputDialog: false,
            errorMsg: ''
        })
    }

    handleReplyDialogShow() {
        this.setState({
            inputDialog: true,
            isReply: true,
            discussSheetShow: false
        })
    }

    handleDiscussInput(e) {
        this.setState({
            inputValue: e.target.value
        })
    }

    handleSendDiscuss() {
        if (this.state.inputValue.trim() === ''){
            this.setState({
                errorMsg: '评论不能为空'
            });
            return
        }

        let data = new FormData();
        data.append('content', this.state.inputValue);

        if (!this.state.isReply) {
            axios.post(`/api/classroom/${this.props.lectureId}/discuss/send `, data)
                .then(res => {
                    if (res.data.code === 0) {
                        this.setState({
                            inputValue: '',
                            errorMsg: '',
                            sendSuccess: true
                        }, () => {
                            this.toastTimer = setTimeout(()=> {
                                this.setState({
                                    sendSuccess: false
                                });
                            }, 1000);
                        })
                    } else {
                        return window._wk_toast.show(res.data.msg, '', 2000) 
                    }
                });
        }else {
            data.append('quote_discuss_id', this.state.selectedId);
            axios.post(`/api/classroom/${this.props.lectureId}/discuss/send `, data)
                .then(res => {
                    if (res.data.code === 0) {
                        let newDiscuss = [{
                            content: this.state.inputValue,
                            is_fake: true,
                            id: Date.parse(new Date()),
                            account: {
                                nickname: this.props.account.nickname
                            }
                        }];
                        let [...newlist] = this.state.list.discusses;
                        let index = newlist.findIndex(item => item.id === this.state.selectedId);
                        newlist[index].replies = newlist[index].replies.concat(newDiscuss);
                        this.setState({
                            list: {
                                ...this.state.list,
                                discusses: newlist
                            }
                        }, () => {
                            this.setState({
                                inputValue: '',
                                errorMsg: '',
                                sendSuccess: true
                            }, () => {
                                this.toastTimer = setTimeout(()=> {
                                    this.setState({
                                        sendSuccess: false
                                    });
                                }, 1000);
                            })
                        })
                    } else {
                        return window._wk_toast.show(res.data.msg, '', 2000) 
                    }
                });
        }

    }

    handleLoadMore() {
        this.setState({
            loading: true
        })
        axios.get(`/api/classroom/${this.props.lectureId}/discuss/list`, {
            params: {
                offset: this.state.list.next_offset,
                need_reply: 1
            }
        })
            .then(res => {
                if (res.data.code === 0) {
                    res.data.data.discusses = this.state.list.discusses.concat(res.data.data.discusses);
                    this.setState({
                        list: res.data.data,
                        loading: false
                    })
                }
            })
    }

    handleBlockUser() {
        let data = new FormData();
        data.append('account_id', this.state.selectedUserId);
        axios.post(`/api/liveroom/${this.props.liveroomId}/block_account`, data)
            .then(res => {
                if (res.data.code === 0){
                    // console.log('拉黑成功');
                    axios.post(`/api/classroom/${this.props.lectureId}/discuss/${this.state.selectedId}/delete`)
                        .then(res => {
                            if (res.data.code === 0){

                                let index = this.state.list.discusses.findIndex((value) => {
                                    return value.id === this.state.selectedId
                                });
                                let list = this.state.list.discusses;
                                list.splice(index, 1);
                                this.setState({
                                    discussSheetShow: false,
                                    list: {
                                        ...this.state.list,
                                        discusses: list,
                                    },
                                    showWarn: true,
                                    tipsContent: '已成功拉黑用户'
                                }, () => {
                                    this.warnTimer = setTimeout(()=> {
                                        this.setState({
                                            showWarn: false,
                                            tipsContent: ''
                                        });
                                    }, 1000);
                                })
                            }
                        })
                }
            })
    }

    handleZan(info) {
        if (this.state.sendingZan)
            return;

        if (info.is_liked){
            this.setState({
                sendingZan: true
            }, () => {
                axios.post(`/api/classroom/${this.props.lectureId}/discuss/${info.id}/cancel_like`)
                    .then(res => {
                        if (res.data.code === 0){
                            let newlist = [...this.state.list.discusses];
                            let index = newlist.findIndex((item) => item.id === info.id);
                            newlist[index].is_liked = false;
                            newlist[index].like_count = newlist[index].like_count - 1;
                            this.setState({
                                list: {
                                    ...this.state.list,
                                    discusses: newlist,
                                },
                                sendingZan: false
                            })
                        }
                    })
            });
        }else {
            this.setState({
                sendingZan: true
            }, () => {
                axios.post(`/api/classroom/${this.props.lectureId}/discuss/${info.id}/like`)
                    .then(res => {
                        if (res.data.code === 0){
                            let newlist = [...this.state.list.discusses];
                            let index = newlist.findIndex((item) => item.id === info.id);
                            newlist[index].is_liked = true;
                            newlist[index].like_count = newlist[index].like_count + 1;
                            this.setState({
                                list: {
                                    ...this.state.list,
                                    discusses: newlist,
                                },
                                sendingZan: false
                            })
                        }
                    })
            })
        }
    }

    handlewReplySheet(info) {
        this.setState({
            deleteDiscussSheetShow: true,
            selectedContent: info
        })
    }

    handleDeleteDiscuss() {
        axios.post(`/api/classroom/${this.props.lectureId}/discuss/${this.state.selectedId}/delete`)
            .then(res => {
                if (res.data.code === 0){
                    let index = this.state.list.discusses.findIndex((value) => {
                        return value.id === this.state.selectedId
                    });
                    let list = this.state.list.discusses;
                    list.splice(index, 1);
                    this.setState({
                        discussSheetShow: false,
                        list: {
                            ...this.state.list,
                            discusses: list,
                        },
                        showWarn: true,
                        tipsContent: '已成功删除评论'
                    }, () => {
                        this.warnTimer = setTimeout(()=> {
                            this.setState({
                                showWarn: false,
                                tipsContent: ''
                            });
                        }, 1000);
                    })
                }
            })
    }

    handleDeleteReplyDiscuss() {
        const {selectedContent} = this.state;
        axios.post(`/api/classroom/${this.props.lectureId}/discuss/${selectedContent.item.id}/delete`)
            .then(res => {
                if (res.data.code === 0){
                    let index = this.state.list.discusses.findIndex((value) => {
                        return value.id === selectedContent.content.id
                    });
                    let deepIndex = this.state.list.discusses[index].replies.findIndex((item) => item.id === selectedContent.item.id);
                    let [...newlist] = this.state.list.discusses;
                    newlist[index].replies.splice(deepIndex, 1);
                    this.setState({
                        deleteDiscussSheetShow: false,
                        list: {
                            ...this.state.list,
                            discusses: newlist,
                        },
                        showWarn: true,
                        tipsContent: '已成功删除回复'
                    }, () => {
                        this.warnTimer = setTimeout(()=> {
                            this.setState({
                                showWarn: false,
                                tipsContent: ''
                            });
                        }, 1000);
                    })
                }
            })
    }

    renderMenus() {
        if (this.props.role.is_manager) {
            return [{
                label: '回复评论',
                onClick: () => this.handleReplyDialogShow()
            }, {
                label: '取消精选',
                onClick: () => this.manageComment('cancel_filtered')
            }, {
                label: this.state.selectedIsTop ? '取消置顶' : '置顶精选',
                onClick: () => this.manageComment(this.state.selectedIsTop ? 'cancel_top' : 'top')
            }]
        }
        if (!this.props.role.is_manager && (this.props.account.id === this.state.selectedUserId)) {
            return [{
                label: '删除评论',
                onClick: ()=> {
                    this.handleDeleteDiscuss()
                }
            }]
        }
    }

    // top, cancel_top, filtered, cancel_filtered
    manageComment (action) {
        this.setState({ discussSheetShow: false })
        axios.post(`/api/lecture/${this.props.lectureId}/discuss/${this.state.selectedId}/manage`, qs.stringify({
            action,
        }))
            .then(res => {
                if (res.data.code === 0) {
                    this.fetchComments()
                    if (['cancel_top', 'cancel_filtered'].includes(action)) {
                        this.showSuccessToast('取消成功')
                    } else {
                        this.showSuccessToast('')
                    }
                } else {
                    alert(res.data.msg)
                }
            })
    }

    renderDeleteMenus() {
        return [{
            label: '删除回复',
            onClick: ()=> {
                this.handleDeleteReplyDiscuss()
            }
        }]
    }

    onClickCommentInput () {
        this.setState({
            inputDialog: true,
            isReply: false
        }, () => {
            document.querySelector('textarea').focus();
        });
    }

    onClickMenu () {
        this.props.dispatch({
            type: 'CLASSROOM_SET_MENU_DISPLAY',
            payload: true,
        })
    }

    render() {
        return (
            <div>

                <Toast icon="success-no-circle" show={this.state.sendSuccess}>发送成功</Toast>

                <Toast icon="success-no-circle" show={this.state.isShowSuccessToast}>{this.state.successToastText || '操作成功'}</Toast>

                <Toptips type="primary" show={this.state.showWarn}>{this.state.tipsContent}</Toptips>

                <ActionSheet
                    menus={this.renderMenus()}
                    actions={this.state.actions}
                    show={this.state.discussSheetShow}
                    type="ios"
                    onRequestClose={e=>this.setState({discussSheetShow: false})}
                />

                <ActionSheet
                    menus={this.renderDeleteMenus()}
                    actions={this.state.deleteActions}
                    show={this.state.deleteDiscussSheetShow}
                    type="ios"
                    onRequestClose={e=>this.setState({deleteDiscussSheetShow: false})}
                />

                {/*用户未授权且评论数为0时不展示*/}
                {!(!this.props.canIListen && (this.state.list && this.state.list.discusses.length === 0)) &&
                <div className="recorded-discuss" style={{height: this.state.list && this.state.list.discusses.length === 0 ? '300px' : 'auto'}}>
                    <div className="discuss-bar">
                        <span>评论{(this.state.count && this.state.count !== 0) ? `（${this.state.count}）` : null}</span>
                    </div>
                    <div className="recorded-discuss-list">
                        {this.state.list && this.state.list.discusses.length === 0 &&
                        <DiscussNone/>
                        }

                        {this.state.list && this.state.list.discusses.length > 0 &&
                        this.state.list.discusses.map((item) => <DiscussItem
                            content={item}
                            key={item.id}
                            handleSheetShow={(info) => this.handleSheetShow(info)}
                            role={this.props.role}
                            account={this.props.account}
                            handleZan={(info) => this.handleZan(info)}
                            handlewReplySheet={(info) => this.handlewReplySheet(info)}
                        />)
                        }

                        {this.state.list &&
                        <WKInfiniteScroll onTouchBottom={() => this.handleLoadMore()}
                                          isStop={this.state.loading}
                                          distance={300}
                                          isKill={!this.state.list.has_more} />
                        }
                    </div>
                </div>
                }

                {this.props.canIListen &&
                <div className={ `recorded-input`}>
                    <WKCommentDialog 
                        type="ios" 
                        title={this.state.isReply ? '回复评论' : '发表评论'} 
                        buttons={this.state.DialogButtons} 
                        show={this.state.inputDialog}
                    >
                        <div className="recorded-textarea">
                            <textarea 
                                rows="3" 
                                value={this.state.inputValue} 
                                onChange={(e) => this.handleDiscussInput(e)}
                                placeholder={this.state.isReply ? '回复的评论将对所有人可见' : '评论将由直播间筛选后显示，对所有人可见'}
                            >
                            </textarea>
                            {this.state.errorMsg !== '' &&
                            <p style={{fontSize: '10px', color: '#f76260', marginTop: '10px', textAlign: 'left'}}>{this.state.errorMsg}</p>
                            }
                        </div>
                    </WKCommentDialog>
                    <div style={{pointerEvents: this.state.inputDialog ? 'none' : 'auto'}}>
                        <div className="input-wrap">
                            {!this.props.account.has_liveroom &&
                            <img src={ToCreateLiveroom} alt="" style={{width: '34px', height: '34px', marginRight: "10px"}} onClick={() => {location.assign('/liveroom/create/guide?fr=lecture')}}/>
                            }
                            <div className="input">
                                <input readOnly onClick={e => this.onClickCommentInput()} type="text" placeholder="发表评论"/>
                            </div>
                            <div className="menu" onClick={e => this.onClickMenu()}>
                                <img src="https://static-1253442168.image.myqcloud.com/picture/6031279_be85c069df9e361e7c55aa75321d7f47.jpg" alt=""/>
                            </div>
                        </div>
                        
                    </div>
                </div>
                }

            </div>
        )
    }
}

export default connect((state) => ({
    account: state.account
}))(DiscussArea)



// WEBPACK FOOTER //
// ./src/pages/recordedPage/DiscussArea.js